// extracted by mini-css-extract-plugin
module.exports = {"containerPaginate":"Paginate_containerPaginate__1mpWD","pageControl":"Paginate_pageControl__3ra3C","pageControlNumber":"Paginate_pageControlNumber__YFNPL"};